<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle *ngIf="!generatingLetters">
  <h5 class="modal-title">Generate Letters</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" *ngIf="!generatingLetters">

  <div class="mb-3 row" *ngIf="!otherLettersOnly">
    <label class="col-sm-3 col-form-label">Letter Type</label>
    <div class="col-sm-9">
      <select class="form-select" 
              [(ngModel)]="letterGroupType" 
              (change)="loadLettersForType()">
        <option [ngValue]="1">Case Letters</option>
        <option [ngValue]="2" *ngIf="caseTypeId == 1 || caseTypeId == 6 || caseTypeId == 7 || caseTypeId == 8">Admin Letters</option>
        <option [ngValue]="3" *ngIf="caseTypeId == 1">Mortgage Letters</option>
        <option [ngValue]="4">Other Letters</option>
      </select>
    </div>
  </div>

  <div class="mb-3 row" *ngIf="letters.length > 0">
    <label class="col-sm-3 col-form-label">Search</label>
    <div class="col-sm-9">
      <input type="text" 
             class="form-control" 
             [(ngModel)]="searchKeyword"
             placeholder="Search...">
    </div>
  </div>

  <div class="letter-list" *ngIf="letters.length > 0">
    <div class="letter-item" *ngFor="let letter of letters | letterSearch: searchKeyword">
      <app-letter-template [details]="letter"></app-letter-template>
    </div>
  </div>

</div>

<div class="modal-body text-center" *ngIf="generatingLetters && !generatingError">
  <h5>Generating Letters - Please do not leave the page</h5>
  <div class="my-4">
    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div class="modal-body text-center" *ngIf="generatingError">
  <h5 class="text-danger">An Error Occurred</h5>
  <div class="alert alert-danger mt-3">
    {{errorMessage}}
  </div>
</div>

<div class="modal-footer" *ngIf="!generatingLetters && letterGroupType > 0">
  <button type="button" 
          class="btn btn-success" 
          (click)="generateLetters()" 
          [disabled]="!atLeastOneItemSelected()">
    Generate Letters
  </button>
</div>